import { PatientProvider } from '../../../contexts';
import { useFetchOrganization } from '../../../features/organization';
import { Header, Navbar } from './components';
import { IAppLayoutProps } from './types';

export const Layout = ({ id, backButton, rightButtons, children }: IAppLayoutProps) => {
  useFetchOrganization();

  return (
    <PatientProvider>
      <div id={id} className="flex flex-row bg-background-base-alt">
        <Navbar />

        <div className="flex ml-[240px] w-[calc(100%-240px)]">
          <Header backButton={backButton} rightButtons={rightButtons} />
          <div id="contentWrapper" className="w-full p-6 mt-[65px]">
            {children}
          </div>
        </div>
      </div>
    </PatientProvider>
  );
};
